// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../../../shared/src/Store.bs.js");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var WebTypes_Shift = require("../types/WebTypes_Shift.bs.js");
var CommonTypes_Jwt = require("../../../shared/src/types/CommonTypes_Jwt.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebTypes_PostAShift_Step = require("../types/WebTypes_PostAShift_Step.bs.js");
var CommonTypes_ResponsiveLayout = require("../../../shared/src/types/CommonTypes_ResponsiveLayout.bs.js");

var AsyncResultWithDispatchError = Relude_AsyncResult.WithError({});

var IOWithDispatchError = Store.IOWithDispatchError({});

var initialState_shifts = WebTypes_Shift.$$Set.empty;

var initialState = {
  pastPageMarker: /* Init */0,
  shifts: initialState_shifts,
  subscriptions: undefined,
  upcomingPageMarker: /* Init */0
};

var Dashboard = {
  initialState: initialState
};

var initialState_availableShiftSteps = Curry._1(WebTypes_PostAShift_Step.$$Set.fromArray, [/* Location */0]);

var initialState_newShift = {
  basicInfo: undefined,
  dates: undefined,
  details: undefined,
  location: undefined
};

var initialState$1 = {
  availableShiftSteps: initialState_availableShiftSteps,
  currentShiftStep: /* Location */0,
  newShift: initialState_newShift,
  requestableWorkers: /* Init */0,
  savedManagers: /* Init */0,
  shiftTypes: /* Init */0
};

var PostAShift = {
  initialState: initialState$1
};

var initialState_currentDatetime = new Date();

var initialState$2 = {
  currentDatetime: initialState_currentDatetime,
  currentDatetimeUpdateInterval: undefined
};

var Timing = {
  initialState: initialState$2
};

var initialState_layout = Relude_Option.fold(/* Desktop */2, CommonTypes_ResponsiveLayout.fromInt, DomUtils.WindowSizing.screenWidth(undefined));

var initialState_token = Curry._2(Relude_Option.flatMap, CommonTypes_Jwt.fromString, Caml_option.null_to_opt(localStorage.getItem("token")));

var initialState$3 = {
  cities: /* Init */0,
  currentUser: /* Init */0,
  dashboard: initialState,
  editingShift: /* Init */0,
  layout: initialState_layout,
  postAShift: initialState$1,
  savedBusinessAdmins: /* Init */0,
  savedBusinessManagers: /* Init */0,
  savedLocations: /* Init */0,
  token: initialState_token,
  timing: initialState$2,
  view: /* Welcome */1
};

exports.AsyncResultWithDispatchError = AsyncResultWithDispatchError;
exports.IOWithDispatchError = IOWithDispatchError;
exports.Dashboard = Dashboard;
exports.PostAShift = PostAShift;
exports.Timing = Timing;
exports.initialState = initialState$3;
/* AsyncResultWithDispatchError Not a pure module */
